import { Box, Stack, Typography, useTheme } from "@mui/material";
import { delftBlue } from "@/theme/colors";

const PlayIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M12.2666 8.33333L5.99992 12.2533L5.33325 12.6667V4L12.2666 8.33333ZM10.9999 8.33333L5.99992 5.2V11.4667L10.9999 8.33333Z"
      fill="var(--Colour-Neutrals-700, #4D4D4D)"
    />
  </svg>
);

const PauseIcon = () => (
  <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9 12V4H12V12H9ZM4 12V4H7V12H4ZM9.66667 11.3333H11.3333V4.66667H9.66667V11.3333ZM4.66667 11.3333H6.33333V4.66667H4.66667V11.3333Z"
      fill="var(--Colour-Neutrals-600, #666666)"
    />
  </svg>
);

const ActivityStatusBadge = ({ status = "active" }) => {
  const theme = useTheme();
  const isActive = status === "active";

  return (
    <Box
      sx={{
        paddingLeft: { xs: 0.75, sm: 1 },
        paddingRight: { xs: 0.75, sm: 1 },
        paddingTop: { xs: 0.4, sm: 0.5 },
        paddingBottom: { xs: 0.4, sm: 0.5 },
        background: isActive ? theme.palette.neutral[200] : theme.palette.neutral[100],
        borderRadius: 2,
        display: "inline-flex",
        justifyContent: "flex-start",
        alignItems: "center",
        gap: { xs: 0.4, sm: 0.5 },
      }}
    >
      {isActive ? <PlayIcon /> : <PauseIcon />}
      <Typography
        sx={{
          color: isActive ? theme.palette.neutral[700] : theme.palette.neutral[600],
          fontSize: { xs: 12, sm: 13 },
          fontFamily: "Montserrat, sans-serif",
          fontWeight: 500,
          lineHeight: 1.23,
          whiteSpace: "nowrap",
        }}
      >
        {isActive ? "Active" : "Inactive"}
      </Typography>
    </Box>
  );
};

export default ActivityStatusBadge;



